<template>
<div>
    <Breadcrumbs main="Admin" submain="AI Hub" title="Prompt Template" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Template</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="template_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(name)="row">
                                        <div v-if="row.item.name" style="min-width: 150px; max-width: 250px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(category_obj)="row">
                                        <div v-if="row.item.category_obj" style="min-width: 150px; max-width: 200px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.category_obj?.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(is_active)="row">
                                        <span style="display: flex; gap: 12px; cursor: pointer;">
                                            <input class="custom-checkbox" type="checkbox" id="flexSwitchCheck" v-model="row.item.is_active" @change="handleToggle(row.item.id)" />
                                        </span>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteTemplate(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editTemplate(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Template Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Template" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter template title" v-model="template.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="template.category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Prompt</label>
                        <textarea class="form-control" placeholder="Enter prompt" v-model="template.content" :rows="minRows"></textarea>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Template Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Template" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter template title" v-model="edit_template.title">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_template.category">
                            <option disabled value="">Select a category</option>
                            <option v-for="(type, index) in category_list" :key="index" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div> 
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Prompt</label>
                        <textarea class="form-control" placeholder="Enter prompt" v-model="edit_template.content" :rows="minRows"></textarea>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Template Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this template?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            minRows: 12,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category_obj',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'is_active',
                    label: 'Visibility',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            template: {
                title: "",
                content: "",
                category: null
            },
            edit_template: {
                id: null,
                title: "",
                content: "",
                category: null
            },
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            template_list: state => state.key.template,
            category_list: state => state.key.category,
            loading: state => state.key.templateLoading,
            error: state => state.key.templateError
        }),

        sortOptions() {
            return this.tablefields.filter(f => f.sortable).map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("key/fetchCategory")
        this.$store.dispatch("key/fetchTemplate").then(() => {
            this.items = this.template_list
            this.totalRows = this.template_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.template.title = ""
            this.template.content = ""
            this.template.category = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            // this.template.content = JSON.stringify(this.template.content)
            this.$store.dispatch("key/addTemplate", this.template).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editTemplate(detail) {
            this.edit_template.id = detail.id ? detail.id : null
            this.edit_template.title = detail.title ? detail.title : null
            this.edit_template.content = detail.content ? detail.content : null
            this.edit_template.category = detail.category_obj ? detail.category_obj.id : null
        },

        resetEditModal() {
            this.edit_template.id = null
            this.edit_template.title = ""
            this.edit_template.content = ""
            this.edit_template.category = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("key/updateTemplate", {
                id: this.edit_template.id,
                template: this.edit_template
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        handleToggle(id) {
            this.$store.dispatch("key/toggleActive", id).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteTemplate(slug) {
            this.delete_value = slug
        },

        handleDeleteOk() {
            this.$store.dispatch("key/deleteTemplate", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.custom-checkbox {
    width: 24px;
    height: 24px;
    display: inline-block;
    background-color: #f0f0f0;
    border-radius: 4px;
    border: 2px solid #262162;
    position: relative;
    margin-right: 10px;
    transition: all 0.2s;
}
</style>